import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const myPatientsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.patientsList.route,
      lazy: () =>
        import("@pages/panelPages/myPatients/patientsList/patientsList"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.patientsList", [], "index", "main");
        return {};
      },
    },
    permissions: ["doctor"],
  },
];
